import styles from './index.module.sass';
import { CoreIcon } from '@autopass-web/mochi-icons';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface powerByProps {
  style?: any;
  className?: any;
  invert?: boolean;
}

const PowerBy = ({ invert = false, style = {}, className }: powerByProps) => {
  const powerByClass = cx({
    powerBy: true,
  });
  return (
    <div className={`${powerByClass} ${className} `} style={style}>
      <CoreIcon
        src={invert ? '/assets/pba_dark.svg' : '/assets/pba_light.svg'}
      />
    </div>
  );
};

export default PowerBy;
